import { Video } from 'lucide-react';
import type { VideoBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const videoConfig: BlockTypeConfig<VideoBlock> = {
  type: 'video',
  label: 'Video',
  description: 'Embed from YouTube or Vimeo, or upload a video',
  icon: Video,
  category: 'media',
  createDefault: () => ({
    url: '',
    width: 'wide',
    aspectRatio: 'video',
    rounded: true,
    shadow: true,
    border: false,
    controls: true,
  }),
  toolbar: [
    { kind: 'media', path: 'data.url', label: 'Video', assetType: 'video' },
    {
      kind: 'select',
      path: 'data.width',
      label: 'Width',
      options: [
        { value: 'full', label: 'Full' },
        { value: 'wide', label: 'Wide' },
        { value: 'medium', label: 'Medium' },
        { value: 'small', label: 'Small' },
      ],
    },
    {
      kind: 'select',
      path: 'data.aspectRatio',
      label: 'Ratio',
      options: [
        { value: 'auto', label: 'Auto' },
        { value: 'video', label: '16:9' },
        { value: 'square', label: '1:1' },
        { value: '4/3', label: '4:3' },
        { value: '9/16', label: '9:16 Vertical' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    {
      kind: 'group',
      label: 'Style',
      fields: [
        { kind: 'toggle', path: 'data.rounded', label: 'Rounded corners' },
        { kind: 'toggle', path: 'data.shadow', label: 'Shadow' },
        { kind: 'toggle', path: 'data.border', label: 'Border' },
      ],
    },
    {
      kind: 'group',
      label: 'Playback',
      fields: [
        { kind: 'toggle', path: 'data.autoplay', label: 'Autoplay (muted)' },
        { kind: 'toggle', path: 'data.muted', label: 'Muted' },
        { kind: 'toggle', path: 'data.loop', label: 'Loop' },
        { kind: 'toggle', path: 'data.controls', label: 'Show controls' },
      ],
    },
    {
      kind: 'group',
      label: 'Caption & poster',
      fields: [
        { kind: 'text', path: 'data.caption', label: 'Caption' },
        { kind: 'media', path: 'data.posterUrl', label: 'Poster image', assetType: 'image' },
      ],
    },
  ],
};
